import {State} from "@store/state";
import {createSelector} from "@ngrx/store";
import { NOF_CONFIGURE_THRESHOLD_PERMISSION } from "@auth/routes/permissions";

const getUserInfos = (state: State) => state.userInfos;

export const getUserAuthorizations = createSelector(
  getUserInfos,
  (state) => state.userAuthorizations
);

export const getIsUserAuthorizedToPushNotif = createSelector(
  getUserAuthorizations,
  (state) => state.isUserAuthorizedToPushNotif
);

export const getNofUserRoles = createSelector(
  getUserAuthorizations,
  (state) => state.nofUserRoles
);

export const getIsUserAuthorizedToConfigureThresholds = createSelector(
  getNofUserRoles,
  (roles) => NOF_CONFIGURE_THRESHOLD_PERMISSION.some((permission) => roles.includes(permission))
);

